
import {
  Component, Mixins,
} from 'vue-property-decorator';
// import { debounce } from 'ts-debounce';
import DataTableWrapper from '@/features/common/components/DataTableWrapper.vue';
import AddAccountModal from '@/features/carrier-accounts/components/AddAccountModal.vue';
import eventBus from '@/features/common/eventBus';
import eventNames from '@/features/common/constants/events';
import { showSuccessAlertDialog, showWarningAlertDialog } from '@/features/common/helpers';
import { CarrierCodeType } from '@/features/shipment/types';
import { CarrierAccountType } from '../types';
import CarrierAccountItem from './CarrierAccountItem.vue';
import { deleteCarrierAccount, getCarrierAccounts } from '../services/carrierAccounts.services';
import MerchantAccountMixin from '../mixins/mixin';

export type InstallingCarrierType = {
  id: number;
  code: keyof typeof CarrierCodeType;
} | null;

@Component({
  components: {
    DataTableWrapper,
    CarrierAccountItem,
    AddAccountModal,
  },
})
export default class CarrierAccountsTable extends Mixins(MerchantAccountMixin) {
  private installingCarrier: InstallingCarrierType = null;

  private carrierAccounts: CarrierAccountType[] = [];

  private loading = false;

  private isLoadMoreHint = true;

  private isShowCarrierAccountModal = false;

  private requestCallCount = 1;

  get isAddCarrierAccountButtonVisible() {
    return this.$route.name !== 'carrier-accounts-edit';
  }

  async created() {
    eventBus.$on(eventNames.FETCH_CARRIER_ACCOUNTS, this.initiateCarrierAccountsFetching);
    eventBus.$on(
      eventNames.SET_INITIAL_INSTALLATION_CARRIER_ACCOUNT,
      this.initializeCarrierAccounts,
    );
  }

  async mounted(): Promise<void> {
    this.initiateCarrierAccountsFetching();

    // TODO: uncomment when backend is ready
    // const onScroll = () => {
    //   this.debounceFetchOnScroll();
    // };

    // window.addEventListener('scroll', onScroll);
  }

  // eslint-disable-next-line class-methods-use-this
  destroyed(): void {
    eventBus.$off(eventNames.FETCH_CARRIER_ACCOUNTS);
    eventBus.$off(eventNames.SET_INITIAL_INSTALLATION_CARRIER_ACCOUNT);
  }

  private initializeCarrierAccounts(
    installingCarrier: InstallingCarrierType,
    initCarriers: CarrierAccountType[],
  ): void {
    this.installingCarrier = installingCarrier;
    this.carrierAccounts = [...initCarriers, ...this.carrierAccounts];
  }

  private async initiateCarrierAccountsFetching() {
    this.loading = true;
    const responseCarriers = await getCarrierAccounts();
    this.loading = false;

    if (responseCarriers.successful && responseCarriers.data?.length) {
      this.carrierAccounts = responseCarriers.data;
    }
  }

  // private debounceFetchOnScroll = debounce(this.fetchMoreCarrierAccountsHandler, 200);

  // private async fetchMoreCarrierAccountsHandler(): Promise<void> {
  //   const callback = async () => {
  //     this.loading = true;

  //     const carrierAccounts = await getCarrierAccounts({
  //       offset: 30 * this.requestCallCount,
  //     });

  //     if (carrierAccounts
  //       && carrierAccounts.successful
  //       && carrierAccounts.data
  //       && carrierAccounts.data.length
  //     ) {
  //       this.carrierAccounts = [...this.carrierAccounts, ...carrierAccounts.data];
  //       this.requestCallCount += 1;
  //     }

  //     this.isLoadMoreHint = !!carrierAccounts.data && carrierAccounts.data.length > 0;
  //     this.loading = false;
  //   };

  //   fetchMoreUsingScrollWindow(callback);
  // }

  private editCarrierAccount(carrierAccount: CarrierAccountType) {
    const { id, carrierCode, isAvailable } = carrierAccount;

    this.$router.push({
      name: isAvailable === false ? 'carrier-accounts-add' : 'carrier-accounts-edit',
      query: {
        carrierCode,
        accountId: id.toString(),
      },
    });
  }

  private deleteCarrierAccount(carrierAccount: CarrierAccountType) {
    eventBus.$once(eventNames.CONFIRMATION_DIALOG, () => {
      this.performDeleteCarrierAccount(carrierAccount.id);
    });

    this.$store.commit('toggleConfirmDialog', {
      show: true,
      content: this.$t('carrierAccounts.deleteAccount.body', {
        carrier: carrierAccount.carrierCode,
        accountNumber: carrierAccount.accountNumber,
        countryCode: carrierAccount.countryCode,
      }),
      title: this.$t('carrierAccounts.deleteAccount.title'),
    });
  }

  private async performDeleteCarrierAccount(carrierAccountId: number) {
    const response = await deleteCarrierAccount(carrierAccountId);

    if (response && response.successful) {
      showSuccessAlertDialog(this.$t('carrierAccounts.deleteAccount.successAlert') as string);

      this.carrierAccounts = this.carrierAccounts.filter(
        (carrier) => carrier.id !== carrierAccountId,
      );

      return;
    }

    showWarningAlertDialog(response.errorMessage);
  }
}
